import React from 'react';
import { FOOTER } from '../constants/wedding';

function Footer() {
  return (
    <div className='footer'>
      <div className='footer__text'>{FOOTER.designedBy}</div>
      <div className='footer__text'>{FOOTER.copyright}</div>
    </div>
  );
}

export default Footer;
